import styled from "styled-components";

export const FormContainer = styled("div")`
  #root_ticker {
    width: 60px;
  }

  #root_mapTo {
    width: 160px;
  }

  #root_createdAt__title {
    display: none;
  }

  #root_updatedAt__title {
    display: none;
  }

  .help-block {
    display: block;
    margin-top: 5px;
    margin-bottom: 10px;
    color: #909293;
  }
`;
